<template>
  <v-card
    tile
    :width="width"
    style="overflow: hidden;"
    height="100%"
  >
    <v-btn
      v-if="!settingAlwaysShowMap"
      color="rgba(100, 100, 100, 0.3)"
      elevation="0"
      fab
      absolute
      style="right: 0;"
      @click="closeMap"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <position-map
      ref="positionMap"
      :height="`${height}px`"
      :selected-category-id="selectedCategoryId"
      :selected-position-ids="selectedPositionIds"
      :check-in="checkInDate"
      :check-out="checkOutDate"
      :occupancy="booking ? booking.adults + booking.children : null"
      :dogs="booking?.dogs"
      always-show-category-availability
      show-availability
      :booking-id="booking?.id ?? 0"
      :booking-client-id="booking?.clientId"
      :is-loading-availability="isLoadingAvailability"
      :has-availability-error="hasAvailabilityError"
      @select-position="selectPosition"
      @unselect-position="unselectPosition"
    ></position-map>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import PositionMap from '@/components/position/Map.vue'

export default {
  name: 'BookingFormMapPanel',
  components: {
    PositionMap
  },
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('bookingForm', {
      categoryPickerValue: 'categoryPickerValue'
    }),
    ...mapGetters('bookingForm', {
      booking: 'activeBooking',
      checkInDate: 'checkInDate',
      checkOutDate: 'checkOutDate',
      hasAvailabilityError: 'hasAvailabilityError',
      isBookingGroup: 'isBookingGroup',
      isLoadingAvailability: 'isLoadingAvailability',
      selectedPositionIds: 'selectedPositionIds',
      settingAlwaysShowMap: 'settingAlwaysShowMap'
    }),
    selectedCategoryId: function () {
      return this.isBookingGroup ? null : this.categoryPickerValue?.id
    }
  },
  methods: {
    closeMap: function () {
      this.$emit('close-map')
    },
    selectPosition: function (position) {
      this.$emit('select-position', position)
    },
    unselectPosition: function () {
      this.$emit('unselect-position')
    },
    zoomToBooking: function () {
      if (this.booking?.position && this.booking.position.id !== 0) {
        this.zoomToSelectedPosition()
        return true
      }

      if (this.booking?.category) {
        this.zoomToCategory(this.booking.category.id)
        return true
      }

      return false
    },
    zoomToSelectedPosition: function () {
      if (!this.booking?.position || this.booking.position.id === 0) {
        return false
      }

      this.$refs.positionMap.zoomToPosition({
        x: this.booking.position.map_x,
        y: this.booking.position.map_y
      })
      return true
    },
    zoomToCategory: function (categoryId) {
      this.$refs.positionMap.zoomToCategory(categoryId)
      return true
    }
  }
}
</script>
